import { useEffect } from 'react';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';
import { reportClientError } from '../lib/system-status';
import { SystemErrorPage } from './SystemErrorPage';

const RELOAD_FLAG = 'rm-chunk-reload';

function isStaleChunkError(err: unknown): boolean {
  const msg =
    err instanceof Error
      ? err.message
      : isRouteErrorResponse(err)
        ? err.statusText
        : String(err);
  const lower = msg.toLowerCase();
  return (
    lower.includes('mime type') ||
    lower.includes('dynamically imported module') ||
    lower.includes('importing a module script failed') ||
    lower.includes('failed to fetch')
  );
}

/** Router error boundary - delegates to the unified system error page. */
export function RouteErrorFallback() {
  const error = useRouteError();
  const staleChunk = isStaleChunkError(error);

  useEffect(() => {
    if (staleChunk) {
      if (!sessionStorage.getItem(RELOAD_FLAG)) {
        sessionStorage.setItem(RELOAD_FLAG, '1');
        window.location.reload();
      }
      return;
    }

    const message =
      error instanceof Error
        ? error.message
        : isRouteErrorResponse(error)
          ? `${error.status} ${error.statusText}`
          : 'Route error';

    reportClientError({
      kind: 'route_error',
      message,
      stack: error instanceof Error ? error.stack : undefined,
    });
  }, [error, staleChunk]);

  if (staleChunk) {
    return <SystemErrorPage reason="updating" />;
  }

  return <SystemErrorPage reason="unexpected" onRetry={() => window.location.reload()} />;
}
